module.exports = __webpack_public_path__ + "img/simply-caribbean-logo-rgb.fd6055a1.jpg";